module.exports = __webpack_public_path__ + "media/images/icon__matchdayNavigation--pagination--arrow@2x-d1b6b425b1181a1f1dc58f68e192eaac.png";